import './chart_settings_controller';

import * as angular from 'angular';

import area from './chart_area_settings.html';
import bar from './chart_bar_settings.html';
import linePlusBar from './chart_line_plus_bar_settings.html';
import line from './chart_line_settings.html';
import pie from './chart_pie_settings.html';
import scatter from './chart_scatter_settings.html';
import { chartModule } from '../../chart.module';

const templates = {
  line,
  linePlusBar,
  scatter,
  area,
  pie,
  bar,
};

chartModule.directive('modeChartSettings', function () {
  return {
    template: function (elem, attrs: any) {
      if (templates[attrs.chartType]) {
        return templates[attrs.chartType];
      }

      return templates.bar;
    },

    scope: {
      view: '=',
      data: '=',
      chartToken: '=',
      currentTheme: '=',
    },

    controller: 'ChartSettingsController',
  };
});
